import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppDispatch } from '../../modules/hooks';
import { useQueryParams } from '../utils/useQueryParams';
import {
  cleanupSharedState,
  fetchSearchResults,
} from '../../modules/search/actions';

const DEBOUNCE_IN_MILLISECONDS = 300;

const QUERY_PARAM_NAME = 'q';

export const useSearchBox = () => {
  const timeoutRef = useRef<number>();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { [QUERY_PARAM_NAME]: q = '' } = useQueryParams<'q'>();
  const [query, setQuery] = useState(q);
  const [value, setValue] = useState(query);

  const setNewQuery = (newQuery: string) => {
    setQuery(newQuery);

    const params = new URLSearchParams(history.location.search);
    if (newQuery) {
      params.set(QUERY_PARAM_NAME, newQuery);
    } else {
      params.delete(QUERY_PARAM_NAME);
    }

    history.replace({ search: params.toString() });
  };

  const refine = (newQuery: string, skipDebounce?: boolean) => {
    setValue(newQuery);

    window.clearTimeout(timeoutRef.current);

    if (skipDebounce) {
      setNewQuery(newQuery);
    } else {
      timeoutRef.current = window.setTimeout(() => {
        setNewQuery(newQuery);
      }, DEBOUNCE_IN_MILLISECONDS);
    }
  };

  const reset = () => refine('', true);

  useEffect(() => {
    return () => {
      dispatch(cleanupSharedState());

      window.clearTimeout(timeoutRef.current);
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchSearchResults({ query, vendor: 'vgtv' }));
  }, [dispatch, query]);

  return {
    query: value,
    refine,
    reset,
  };
};
